"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALPHA_ProductCardCarousel = void 0;
var react_1 = __importStar(require("react"));
var BaseCarousel_1 = require("../base-carousel/BaseCarousel");
var classnames_1 = __importDefault(require("classnames"));
var ProductCardCarousel_module_scss_1 = __importDefault(require("./ProductCardCarousel.module.scss"));
/**
 * Renders a carousel of product cards
 * @param {string} id - Unique identifier for the carousel
 * @param {string} ariaLabel - Aria label for accessibility
 * @param {string} heading - Heading text for the carousel
 * @param {ReactElement} children - Child elements to be displayed in the carousel
 * @returns {ReactElement} ProductCardCarousel component
 */
var ALPHA_ProductCardCarousel = function (_a) {
    var _b;
    var id = _a.id, ariaLabel = _a.ariaLabel, heading = _a.heading, children = _a.children;
    var _c = (0, react_1.useState)(false), isReady = _c[0], setIsReady = _c[1];
    (0, react_1.useEffect)(function () {
        if (isReady === false) {
            setIsReady(true);
        }
    }, [isReady]);
    return (react_1.default.createElement("div", { "data-testid": "product-card-carousel", className: (0, classnames_1.default)(ProductCardCarousel_module_scss_1.default['product-card-carousel'], (_b = {},
            _b[ProductCardCarousel_module_scss_1.default['product-card-carousel--ready']] = isReady,
            _b)) },
        react_1.default.createElement(BaseCarousel_1.ALPHA_BaseCarousel, { id: id, heading: heading, numberOfItemsToShow: 5, ariaLabel: ariaLabel }, children)));
};
exports.ALPHA_ProductCardCarousel = ALPHA_ProductCardCarousel;
//# sourceMappingURL=ProductCardCarousel.js.map